import React from 'react';
import { Link } from 'react-router-dom';
import BrandLogo from '../ui/BrandLogo';

const PublicLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="min-h-screen bg-slate-950 text-white">
    <header className="border-b border-white/10 bg-slate-950/90 backdrop-blur-xl">
      <nav className="mx-auto flex max-w-6xl items-center justify-between gap-5 px-5 py-4" aria-label="Main navigation">
        <Link to="/" aria-label="mapbl home"><BrandLogo className="h-auto w-32" /></Link>
        <div className="flex items-center gap-4 text-sm text-slate-300">
          <Link className="hidden transition hover:text-cyan-300 md:inline" to="/stories">Stories</Link>
          <Link className="hidden transition hover:text-cyan-300 md:inline" to="/places">Places</Link>
          <Link className="hidden transition hover:text-cyan-300 sm:inline" to="/how-it-works">How it works</Link>
          <Link className="hidden transition hover:text-cyan-300 sm:inline" to="/developer">Developers</Link>
          <Link className="hidden transition hover:text-cyan-300 sm:inline" to="/safety">Safety</Link>
          <Link className="rounded-full border border-white/15 px-4 py-2 font-medium transition hover:border-cyan-400 hover:text-cyan-300" to="/login">Sign in</Link>
          <Link className="rounded-full bg-gradient-to-r from-cyan-500 to-violet-500 px-4 py-2 font-semibold shadow-lg shadow-cyan-500/20 transition hover:brightness-110" to="/register">Join the map</Link>
        </div>
      </nav>
    </header>
    {children}
    <footer className="border-t border-white/10 px-5 py-8 text-sm text-slate-400">
      <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-4">
        <p>© {new Date().getFullYear()} mapbl. People make the map.</p>
        <div className="flex flex-wrap gap-5"><Link to="/stories">Stories</Link><Link to="/people">People</Link><Link to="/places">Places</Link><Link to="/how-it-works">How it works</Link><Link to="/developer">Developers</Link><Link to="/safety">Safety</Link><Link to="/privacy">Privacy</Link></div>
      </div>
    </footer>
  </div>
);

export default PublicLayout;
